import { Stool } from '../parts/seating'
import type { AssetContext, AssetDefinition } from '../types'

/** Seat top heights: bar counter and mid-height poseur table. */
const HEIGHTS: Record<string, number> = {
  alto: 0.75,
  medio: 0.62,
}

/**
 * Bar stool — a thin wrapper over the shared `Stool` assembly (disc foot,
 * single column, footring, round cushion).
 *
 * Origin at the centre of the 0.42 x 0.42 footprint, y = 0 on the floor. The
 * form is radially symmetric, so there is no meaningful front.
 */
function StoolBar({ variant = 'alto' }: AssetContext) {
  return <Stool tone="dark" frameTone="metal" height={HEIGHTS[variant] ?? HEIGHTS.alto} />
}

export const definition: AssetDefinition = {
  id: 'stool-bar',
  name: 'Taburete alto',
  category: 'seating',
  footprint: [0.42, 0.42],
  // Seat top of the tall variant; the `medio` variant tops out at 0.62.
  height: 0.75,
  seats: 1,
  occupantSide: 'front',
  seatInset: 0.21,
  variants: [
    { id: 'alto', name: 'Alto' },
    { id: 'medio', name: 'Medio' },
  ],
  keywords: [
    'taburete',
    'banco',
    'barra',
    'alto',
    'cafetería',
    'breakout',
    'stool',
    'bar stool',
    'counter stool',
  ],
  Component: StoolBar,
}
